import { CompanyId } from '@business/entities/companies';
import {
  EncryptionRequest,
  EncryptionResponse,
  GHLAccountResponse,
  GHLItemResponse,
  IntegrationId,
  IntegrationResponse,
  IntegrationType,
  IntuitUpdateSettings,
  QBUpdateSettings,
  CustomFieldResponse,
  ClickupUpdateSettings,
  RaveCustomFieldResponse,
} from '@business/entities/integration';
import { QBAccountItem, QBPaymentMethodItem } from '@business/entities/organization';
import { SalesTaxLineItems } from '@modules/common/InvoiceSalesTax';
import { Endpoint } from '../endpoint';
import { QBCustomField, QBImportRequest, QBModulesResponse } from './../../entities/organization/PaymentResponse';

export function createIntegration(data: Partial<IntegrationResponse>) {
  return Endpoint.post<IntegrationResponse>(`@gc/integrations`, { data });
}

export function updateQBSettings(data: QBUpdateSettings) {
  return Endpoint.post<IntegrationResponse>(`@gc/integrations/qb`, { data });
}

export function updateClickupSettings(data: ClickupUpdateSettings) {
  return Endpoint.post<IntegrationResponse>(`@gc/integrations/clickup`, { data });
}

export function updateIntuitSettings(data: IntuitUpdateSettings) {
  return Endpoint.post<IntegrationResponse>(`@gc/integrations/intuit`, { data });
}

export function importQB(data: QBImportRequest) {
  return Endpoint.post<void>(`@gc/integrations/qb-import`, { data });
}

export function importStripe(data: QBImportRequest) {
  return Endpoint.post<void>(`@gc/integrations/stripe-import`, { data });
}

export function importAuthorize(data: QBImportRequest) {
  return Endpoint.post<void>(`@gc/integrations/authorize-import`, { data });
}

export function deleteIntegration(id: IntegrationId) {
  return Endpoint.delete<void>(`@gc/integrations/${id}`);
}

export function getQBPaymentMethods() {
  return Endpoint.get<QBPaymentMethodItem[]>(`@gc/integrations/qb-payment-methods`);
}
export function getQBAccounts(companyId: CompanyId) {
  return Endpoint.get<QBAccountItem[]>(`@gc/integrations/qb-accounts/${companyId}`);
}

export function getQBCustomFields(companyId: CompanyId) {
  return Endpoint.get<QBCustomField[]>(`@gc/integrations/qb-custom-fields/${companyId}`);
}

export function getQBModules(companyId: CompanyId) {
  return Endpoint.get<QBModulesResponse>(`@gc/integrations/qb-modules/${companyId}`);
}

export function getStripeModules(companyId: CompanyId) {
  return Endpoint.get<QBModulesResponse>(`@gc/integrations/stripe-modules/${companyId}`);
}

export function getAuthorizeModules(companyId: CompanyId) {
  return Endpoint.get<QBModulesResponse>(`@gc/integrations/authorize-modules/${companyId}`);
}

export function getGHLForms(apiKey: string) {
  return Endpoint.post<GHLItemResponse>(`@gc/integrations/ghl-forms`, { data: { apiKey } });
}

export function getGHLAccounts() {
  return Endpoint.get<GHLAccountResponse[]>(`@gc/integrations/ghl-accounts`);
}
export function getEncryptedKey(data: EncryptionRequest) {
  return Endpoint.get<EncryptionResponse>(`@gc/integrations/encrypted-key`, { params: data });
}

export function saveConnection(data: string) {
  return Endpoint.post<EncryptionResponse>(`@gc/integrations/rave-connection`, { data: { key: data } });
}
export function calculateTax(type: IntegrationType, lines: SalesTaxLineItems[], addressId: string) {
  return Endpoint.post<number>(`@gc/integrations/calculate-tax/${type}`, { data: { lines, addressId } });
}

export function syncGemsOne() {
  return Endpoint.post<void>(`@gc/integrations/sync-gems-one`, { data: {} });
}

export function getSurveyMonkeyAuthUrl(companyId: CompanyId) {
  return Endpoint.post<{ url: string }>(`@gc/integrations/survey-monkey-endpoint`, { data: { companyId } });
}

export function getContactCustomFields() {
  return Endpoint.get<CustomFieldResponse[]>(`@gc/integrations/ac-custom-fields`);
}

export function getRaveCustomFields(comapnyId: string) {
  return Endpoint.get<RaveCustomFieldResponse[]>(`@gc/integrations/rave-custom-fields/${comapnyId}`);
}
